module.exports = __webpack_public_path__ + "static/media/tourVers.9c8eb581.png";